import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';

import {MantineDataTable, TableSearchForm} from '@flexinet/ui-components';
import {DataTableTokenPagination} from '../../../components/DataTableTokenPagination';
import {usePaymentEvents} from '../hooks/usePaymentEvents';
import {useTableColumns} from '../hooks/useTableColumns';

interface RecordsTableProps {
    invoiceId?: string;
}

export const RecordsTable = ({invoiceId}: RecordsTableProps) => {

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword,
    } = usePaymentEvents(invoiceId);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const {columns} = useTableColumns();

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination
                totalCount={totalCount.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchRecords}
            />
        </SimpleGrid>
    );
};
